import React from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import EXP from '../../../../../lib/IssueMapping/Expectations'
import { ExpectationQuestionnaire } from '../../../../../lib/Questionnaires'
import { IGAO } from '../../../../igao'
import IssueQueuer from '../../../../shared/IssueQueuer'
import { CircularProgress } from '../../../../shared/NarusMaterial'
import * as Actions from '../../lib/new-actions'

import ExpectationsForm from './form'

const CATEGORY = 'Expectations'

class Expectations extends React.Component {
  UNSAFE_componentWillMount () {
    this.props.dispatch(
      Actions.getAssessment(
        this.props.params.id,
        CATEGORY,
        ExpectationQuestionnaire
      )
    )
  }

  handleSubmit = data => {
    this.queueIssues(data)
    const { currentUser } = this.props
    this.props.dispatch(
      Actions.createAssessment(
        data,
        this.props.params.id,
        currentUser.id,
        CATEGORY,
        this.props.encounter.document.context_id,
        ExpectationQuestionnaire
      )
    )
  }

  queueIssues = data => {
    const iq = new IssueQueuer({
      dispatch: this.props.dispatch,
      patientId: this.props.patientId,
      practitionerId: this.props.practitionerId,
      encounterId: this.props.encounterId
    })

    iq.queueIssues({
      mapping: EXP,
      currentForm: data,
      existingForms: undefined
    })
  }

  render () {
      const formData = this.props.questionnaire?.[CATEGORY]?.formData ?? {}

      const loading = this.props.questionnaire?.[CATEGORY]?.loading

    const assessmentContent = (
      <ExpectationsForm
        onSubmit={this.handleSubmit}
        initialValues={formData}
        onCancel={() => {
          this.props.dispatch(
            Actions.getAssessment(
              this.props.params.id,
              CATEGORY,
              ExpectationQuestionnaire
            )
          )
        }}
      />
    )

    return (
      <div className='main'>
        <h1>Expectations</h1>

        <div className='row'>
          {loading ? <CircularProgress /> : assessmentContent}
        </div>
        <IGAO
          path='expectation'
        />
      </div>
    )
  }
}

const mapStateToProps = redux => {
  const patientId = redux?.globalVars?.params?.id
  const { questionnaire } = redux
  const currentUser = redux.users.current_user
  const practitionerId = redux.auth.profile.sub
  const encounterId = redux.encounter?.encounter?.id
  const encounter = redux.encounter?.encounter
  return {
    questionnaire,
    currentUser,
    practitionerId,
    patientId,
    encounterId,
    encounter
  }
}

export default connect(mapStateToProps)(withLegacyRouter(Expectations))
